import React, { useState, useEffect } from 'react';
import '../assets/audioplayer.css';
import { styles } from '../assets/styles';
import { pokemonEmojis } from '../data/pkmnEmojis';
import { getPokemonFromStorageEmoji } from '../services/getPokemonFromStorage';

function EmojiSet() {
  const fetchCountEmoji = parseInt(localStorage.getItem('fetch_count_emoji')) || 0;
  const [visibleEmojis, setVisibleEmojis] = useState(0); // estado para almacenar los emojis visibles

  const randomPokemon = getPokemonFromStorageEmoji();
  const pokemonId = randomPokemon?.id;
  const pokemonEmoji = pokemonEmojis.find((pokemon) => pokemon.id === pokemonId)?.emojis;

  useEffect(() => {
    setVisibleEmojis(fetchCountEmoji + 1);
  }, [fetchCountEmoji]);

  if (!pokemonEmoji) {
    return (
      <div style={styles.loading}>
        <div style={styles.loadingText}>Loading POKéMON info...</div>
        <div className="circle" style={styles.loadingCircle} />
      </div>
    );
  }

  console.log(pokemonEmoji);

  return (
    <div style={styles.pokeBoxEmoji1}>
      <div style={styles.pokeBoxEmoji2}>
        <div style={styles.pokeBoxEmoji3}>
          <div style={styles.pokeBoxEmoji4}>
            {pokemonEmoji && (
              <div style={styles.emojiSetContainer}>
                {Array.from(pokemonEmoji).map((emoji, index) => (
                  <span
                    key={index}
                    style={{
                      ...styles.emoji,
                      opacity: index < visibleEmojis ? 1 : 0,
                      paddingRight: '5px',
                    }}
                  >
                    {emoji}
                  </span>
                ))}
                {visibleEmojis < 2 && (
                  <div className="hover" style={styles.emojiHover}>
                    <p />
                    ?
                  </div>
                )}
                {visibleEmojis < 3 && (
                  <div className="hover" style={styles.emojiHover2}>
                    <p />
                    ?
                  </div>
                )}
                <div style={styles.emojiText}>Each try unlocks an emoji.</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmojiSet;
